import React, { PureComponent } from 'react';
import window from 'window-or-global';

import waitForGlobal from '@confluence-classic/confluence-frontend-server/src/lib/wait-for-global-PLEASE-AVOID-USING';

import { getBuildInfo } from '@confluence/build-info';

import type { InjectedProps } from '../../decorators/withMediaClientConfig';
import withMediaClientConfig from '../../decorators/withMediaClientConfig';
import type { MediaViewerItem } from './media-viewer-legacy/media-viewer';

import type { MediaViewerComponentProps, MediaViewerComponentState } from './types';

class MediaViewerComponent extends PureComponent<
	MediaViewerComponentProps & InjectedProps,
	MediaViewerComponentState
> {
	mounted?: boolean;

	static defaultProps = {
		media: [],
		isOpen: false,
	};

	state: MediaViewerComponentState = {};

	componentDidMount() {
		this.mounted = true;
		this.waitForUnderscore = waitForGlobal(
			{
				listener: 'MediaViewerComponent.tsx',
				globalProperty: '_',
			},
			() => {
				const legacyMediaLoader = import(
					/* webpackChunkName: "loadable-media-viewer-legacymedia-viewer" */ './media-viewer-legacy/media-viewer'
				);

				const mediaLoader = import(
					/* webpackChunkName: "loadable-atlaskitmediaviewer" */ '@atlaskit/media-viewer'
				);

				// side effect import - populates AJS.I18n with strings for media viewer :(
				const mediaTranslationsLoader = import(
					/* webpackChunkName: "loadable-atlassianmediaviewerlibtranslationsen" */ '@atlassian/mediaviewer/lib/translations.en'
				);

				void Promise.all([legacyMediaLoader, mediaLoader, mediaTranslationsLoader]).then(
					(imports) => {
						if (this.mounted) {
							this.setState({
								LegacyMediaViewer: imports[0].MediaViewer,
								MediaViewerConstructor: imports[1].MediaViewer,
							});
						}
					},
				);
			},
		);
	}

	componentWillUnmount() {
		this.mounted = false;
		if (this.waitForUnderscore) {
			this.waitForUnderscore.cancel();
		}
	}

	waitForUnderscore: any = null;

	onClose = () => {
		const { parentId, closePreviewer } = this.props;
		closePreviewer({ parentId });
	};

	renderLegacyMediaViewer() {
		const { mediaClientConfig, currentMediaItem, media } = this.props;

		const { MediaViewerConstructor, LegacyMediaViewer } = this.state;

		if (!MediaViewerConstructor || !LegacyMediaViewer) {
			return null;
		}

		const list: MediaViewerItem[] = media.map((file) => ({
			id: file.id,
			occurrenceKey: file.occurrenceKey,
			type: file.mediaItemType,
		}));

		const selectedItem = list.find((file) => file.id === currentMediaItem);
		if (!selectedItem) {
			return null;
		}

		const selectedMedia = media.find((file) => file.id === currentMediaItem);
		const collectionName = (selectedMedia && selectedMedia.collectionName) || '';

		const mediaViewerNGProps = {
			collectionName,
			mediaClientConfig,
			onClose: this.onClose,
			selectedItem,
			dataSource: {
				list,
			},
		};

		let publicPath = getBuildInfo().PUBLIC_PATH;
		if (!publicPath.endsWith('/')) publicPath += '/';
		const basePath = `${publicPath}mediaviewer/`;

		const mediaViewerLegacyProps = {
			...mediaViewerNGProps,
			MediaViewer: MediaViewerConstructor,
			mediaViewerConfiguration: {
				// @ts-ignore TODO FIXME we really don't need typings for "window-or-global", we need to get rid of it instead
				i18n: window.AJS.I18n.keys,
			},
			basePath,
		};
		// MS-751
		return <LegacyMediaViewer {...mediaViewerLegacyProps} />;
	}

	render() {
		const { currentMediaItem, isOpen } = this.props;

		if (!isOpen || !currentMediaItem) {
			return null;
		}

		return this.renderLegacyMediaViewer();
	}
}

export default withMediaClientConfig(MediaViewerComponent);
